// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { formatFullDate, getDateFromString } from 'utils/dateUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

import NewsRow from 'components/fragments/NewsRow';

import type { ArticleType } from 'types/Article';

type Props = {
  articles: Array<ArticleType>,
  slug: string,
  label: string,
  extraClasses?: string,
};

class FooterTeamArticle extends PureComponent<Props> {
  static defaultProps = {
    extraClasses: '',
  };

  props: Props;

  renderArticles = (): any => {
    const { articles } = this.props;
    return articles.map((article, index) => {
      if (index < 4) {
        return(
          <div className="col col-md-4 col-lg-3" key={`${article.title}_${index}`}>
            <NewsRow
              slug={article.slug}
              categorySlug={article.label.slug}
              categoryName={article.label.name}
              className={'news news--score-thumbnail'}
              titleClassName={'news__title ft-h5'}
              img={article.illustration}
              title={article.title}
              date={formatFullDate(getDateFromString(article.date))}
            />
          </div>
        );
      }
      return null;
    });
  };

  render() {
    const { extraClasses } = this.props;
    const containerClassNames = dynamicClassName('section section-white');
    extraClasses && containerClassNames.add(extraClasses);

    return (
      <section className={containerClassNames.build()}>
        <div className="row">
          <div className="col">
            <Link
              to={`/actualites/${this.props.slug}`}
              title={`Voir plus`}
              className="link-chevron link-chevron--right section__link mt-1"
              data-label=""
            >
              <span>{`Voir toute l'actualité de l'équipe`}</span>
              <i className="icon icon-chevron-right" />
            </Link>
            <h3 className="ft-h2 mb-3 mb-lg-4">{`Actualités de l'équipe`}</h3>
            <div className="block-cards-news">
              <div className="row mb-2 mb-md-0">
              {this.renderArticles()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FooterTeamArticle;
